import { Popover } from "./Popover";
import Placements from "./Placements";
export default Popover;
export { Popover, Placements };
